import React from 'react';

import styles from './table-header.scss';

interface Props {
  children: any;
  dataHook: string;
}

const TableHeader = ({ children, dataHook }: Props) => {
  return (
    <div data-hook={dataHook} className={styles.header}>
      {children}
    </div>
  );
};

export default TableHeader;
